import React from "react";
import { connect } from "react-redux";
import { Field, formValueSelector } from "redux-form";
import PropTypes from "prop-types";
import DashedSeparator from "MODULES/shared/components/DashedSeparator/DashedSeparator";
import {
  form,
  Form as AppForm,
  Select,
  FormInput,
  CheckGroup,
  Check,
  AutoCompleteUserInputField
} from "MODULES/shared/components/Forms";
import AutoCompleteField from "MODULES/shared/components/Forms/AutoCompleteField/AutoCompleteField";
import { toOptions } from "LIB/forms";
import { searchParts } from "MODULES/parts/actions/actions";
import MonthYearField from "MODULES/shared/components/Forms/MonthYearField/MonthYearField";
import {
  TAG_DATE_CONDITIONS,
  CONDITION_TYPES,
  RECEIVING_TYPES,
  RECEIVING_TYPE,
  EMA,
  CONSIGNMENT,
  CONSIGNOR_PERCENTAGE,
  CONSIGNMENT_BUYER_ID,
  CONSIGNMENT_CO_BUYER_ID,
  CONSIGNMENT_BUYER,
  CONSIGNMENT_CO_BUYER,
  CONSIGNMENT_REFERENCE_COMPANY_ID,
  CONSIGNMENT_REFERENCE_COMPANY
} from "MODULES/Receiving/constants";
import {
  ROLE,
  SUBROLE,
  USER,
  WAREHOUSE,
  WAREHOUSE_BASIC
} from "MODULES/users/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col, FormGroup } from "react-bootstrap";
import {
  CONDITION,
  EXPIRATION,
  IMPERFECT_TRACE_REASONS,
  LOCATION,
  PART_ID,
  SERIAL_NUMBER,
  TAG_DATE,
  TAGGED_BY
} from "MODULES/inventories/constants";
import { AWB_NUMBER, QUANTITY } from "APP_ROOT/constants";
import { DOM } from "MODULES/parts/constants";
import BuyerField from "MODULES/PurchaseOrders/shared/CoBuyersFields/BuyerField";
import * as poActions from "MODULES/PurchaseOrders/actions";
import api from "APP_ROOT/api";
import {
  ACTIVE,
  CREDIT_HOLD,
  IMPERFECT_TRACE,
  IMPERFECT_TRACE_REASON
} from "MODULES/companies/constants";
import { properCase } from "LIB/formatters/text";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import validate from "./validate";
import * as actions from "../actions";

export class Form extends React.Component {
  state = {
    selectedPart: {},
    selectedTaggedBy: this.props.taggedBy
  };

  componentWillMount() {
    if (this.props.selectedPart) {
      const state = { selectedPart: this.props.selectedPart };

      if (this.props.receivingRecord) {
        state.selectedConsignmentBuyer = this.props.receivingRecord[
          CONSIGNMENT_BUYER
        ];
        state.selectedConsignmentCoBuyer = this.props.receivingRecord[
          CONSIGNMENT_CO_BUYER
        ];

        state.selectedConsignor = this.props.receivingRecord[
          CONSIGNMENT_REFERENCE_COMPANY
        ];
      }

      this.setState(state);
    }
  }

  setTaggedBy = company => {
    this.setState({ selectedTaggedBy: company });
  };

  handlePartSelected = part => {
    this.setState({ selectedPart: part });
  };

  searchCompanies = filter =>
    api.companies
      .search({
        filter,
        status: [ACTIVE, CREDIT_HOLD].join(","),
        page: 1,
        limit: 20
      })
      .then(resp => resp.data.results);

  render() {
    const {
      queryParts,
      condition,
      currentUser,
      getFieldValue,
      receivingType
    } = this.props;
    const {
      selectedPart,
      selectedConsignor,
      selectedConsignmentBuyer,
      selectedConsignmentCoBuyer,
      selectedTaggedBy
    } = this.state;
    const isBasicWarehouseUser =
      currentUser.get(ROLE) === WAREHOUSE &&
      currentUser.get(SUBROLE) === WAREHOUSE_BASIC;

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <h2>Verify Part Details</h2>
          <FormRow>
            <Col md={4}>
              <Field
                name={RECEIVING_TYPE}
                component={Select}
                options={toOptions(RECEIVING_TYPES)}
                label={properCase(RECEIVING_TYPE)}
                required
                disabled
              />
            </Col>
            <Col md={5}>
              <Field
                name={PART_ID}
                label="Part #"
                placeholder="Type a part's number..."
                component={AutoCompleteField}
                search={queryParts}
                selectedItem={selectedPart}
                formatItem={result => result && result.part_number}
                onItemSelected={i => i && this.handlePartSelected(i)}
                disabled={isBasicWarehouseUser}
                required
              />
            </Col>
            <Col md={3}>
              <Field
                name={SERIAL_NUMBER}
                component={FormInput}
                label="Serial #"
                disabled={isBasicWarehouseUser}
              />
            </Col>
          </FormRow>
          <DashedSeparator />
          <FormRow>
            <Col md={3}>
              <Field
                name={CONDITION}
                component={Select}
                options={toOptions(CONDITION_TYPES)}
                label="Condition Received"
                required
                disabled={isBasicWarehouseUser}
              />
            </Col>
            <Col md={2}>
              <Field
                name={QUANTITY}
                component={FormInput}
                label="Qty Received"
                required
                disabled={isBasicWarehouseUser}
              />
            </Col>
            <Col md={4}>
              <div className="form-group">
                <MonthYearField
                  name={DOM}
                  component={FormInput}
                  label={DOM.toUpperCase()}
                  disabled={isBasicWarehouseUser}
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <Field
                  name={EXPIRATION}
                  component={FormInput}
                  type="date"
                  label="Exp"
                  disabled={isBasicWarehouseUser}
                />
              </div>
            </Col>
          </FormRow>
          <FormRow>
            <Col md={3}>
              <MonthYearField
                name={TAG_DATE}
                component={FormInput}
                label={properCase(TAG_DATE)}
                required={TAG_DATE_CONDITIONS.includes(condition)}
                disabled={isBasicWarehouseUser}
              />
            </Col>
            <Col md={4}>
              <Field
                component={AutoCompleteUserInputField}
                disabled={isBasicWarehouseUser}
                formatItem={result => (result && result.name) || result}
                handleTaggedBy={item => this.setTaggedBy(item)}
                selectedItem={selectedTaggedBy}
                label={properCase(TAGGED_BY)}
                name={TAGGED_BY}
                placeholder="Search by a company's name"
                search={this.searchCompanies}
              />
            </Col>
            <Col md={3}>
              <Field name={AWB_NUMBER} component={FormInput} label="AWB #" />
            </Col>
            <Col md={2}>
              <Field
                name={LOCATION}
                component={FormInput}
                label={properCase(LOCATION)}
                required
                disabled={isBasicWarehouseUser}
              />
            </Col>
          </FormRow>
          <FormRow>
            <Col md={3}>
              <Field
                name="read_only_consignment"
                component={FormInput}
                label="Consignment #"
                disabled
              />
            </Col>
            <Col md={6}>
              <CheckGroup checkGroupStyles={{ marginTop: 0 }} justified>
                <Field
                  name="demerit"
                  component={Check}
                  label="Escalate Discrepancy"
                />
              </CheckGroup>
            </Col>
          </FormRow>
          {[EMA, CONSIGNMENT].includes(receivingType) && (
            <FormRow>
              <Col md={3}>
                <Field
                  name={CONSIGNMENT_REFERENCE_COMPANY_ID}
                  label="Consignment Ref Co."
                  placeholder="Search by a company's name"
                  component={AutoCompleteField}
                  onItemSelected={item =>
                    this.setState({ selectedConsignor: item })}
                  search={this.searchCompanies}
                  selectedItem={selectedConsignor}
                  formatItem={result => result && result.name}
                  required
                />
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Field
                    label="Consignor %"
                    name={CONSIGNOR_PERCENTAGE}
                    component={FormInput}
                    type="number"
                    inputProps={{
                      min: 0,
                      max: 100
                    }}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <BuyerField
                    label="Cons. Buyer Credit"
                    name={CONSIGNMENT_BUYER_ID}
                    searchBuyers={this.props.searchBuyers}
                    selectedBuyer={selectedConsignmentBuyer}
                    onItemSelected={item =>
                      this.setState({ selectedConsignmentBuyer: item })}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <BuyerField
                    label="Cons. Co Buyer Credit"
                    name={CONSIGNMENT_CO_BUYER_ID}
                    required={false}
                    searchBuyers={this.props.searchBuyers}
                    selectedBuyer={selectedConsignmentCoBuyer}
                    onItemSelected={item =>
                      this.setState({ selectedConsignmentCoBuyer: item })}
                  />
                </FormGroup>
              </Col>
            </FormRow>
          )}
          <FormRow>
            <Col md={getFieldValue(IMPERFECT_TRACE) ? 9 : 12}>
              <CheckGroup justified title="Flags">
                <Field
                  name={IMPERFECT_TRACE}
                  component={Check}
                  label={properCase(IMPERFECT_TRACE)}
                />
                <Field name="der" component={Check} label="DER" />
                <Field name="pma" component={Check} label="PMA" />
                <Field name="modified" component={Check} label="Modified" />
                <Field name="incident" component={Check} label="Incident" />
              </CheckGroup>
            </Col>
            {getFieldValue(IMPERFECT_TRACE) && (
              <Col md={3}>
                <Field
                  name={IMPERFECT_TRACE_REASON}
                  component={Select}
                  options={toOptions(IMPERFECT_TRACE_REASONS)}
                  label="Imperfect Trace Reason"
                />
              </Col>
            )}
          </FormRow>
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  currentUser: PropTypes.shape({}),
  queryParts: PropTypes.func.isRequired,
  condition: PropTypes.string.isRequired,
  receivingType: PropTypes.string.isRequired,
  receivingRecord: PropTypes.shape({}),
  searchBuyers: PropTypes.func.isRequired,
  selectedPart: PropTypes.shape({
    id: PropTypes.number,
    part_number: PropTypes.string
  })
};

const FORM_NAME = "editReceivingRecord";

export default connect(
  state => ({
    currentUser: state.session.get(USER),
    condition: formValueSelector(FORM_NAME)(state, CONDITION)
  }),
  dispatch => ({
    onSubmit: data => dispatch(actions.update(data)),
    queryParts: filter => dispatch(searchParts(filter)),
    searchBuyers: filter => dispatch(poActions.searchBuyers(filter))
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Edit/Form.jsx